export const transformResponseToMessage = data => {
  const transformedData = JSON.parse(data);
  if (!data || !transformedData.message) return null;

  return transformedData.message.msg;
};
